export function matchHeight (sortableList) {
  function match() {
    if(!sortableList) return;
    const list = [...sortableList]
    const data = list.map(item => {
      if (item.style && item.style.height) { item.style.height = ''; }
      return item.getBoundingClientRect()
    });

    const isOnSameRow = data.every(({ top }) => top === data[0].top);
    const sameHeightValue = isOnSameRow ? getHeightValue(data) : '';
    list.forEach(item => (item.style.height = sameHeightValue))
  }

  function getHeightValue (data) {
    return `${Math.max.apply( Math, data.map(({ height }) => height))}px`
  }

  function run() {
    match(sortableList);
  }

  if (sortableList) {
    run()
    window.addEventListener('resize', run);
  }

  return {
    destroy() {
      window.addEventListener('resize', run);
    }
  }
}
